/*
 * @Author: YuanYuan
 * @Date: 2024-08-16 11:03:20
 * @LastEditTime: 2025-08-27 11:29:02
 * @Description: 接口配置
 */
import API_CONFIG from './modules'
import axios from './axios'
import { assign, pick, isEmpty } from 'lodash-es'

const normalizeReq = (options, params) => {
  const method = options.method.toUpperCase()
  if (['POST', 'PUT', 'PATCH'].indexOf(method) > -1) {
    options.data = params
  } else {
    options.params = params
  }
  return options
}

export const toAxios = (apiName, params) => {
  const modulename = apiName.split('/')[0]
  const name = apiName.split('/')[1]
  const moduleApiList = API_CONFIG[modulename]
  const theApi = moduleApiList.find(item => item.name === name)
  const { path, method } = theApi
  return axios(normalizeReq({ url: path, method }, params))
}

class ApiMaker {
  constructor(options) {
    this.api = {}
    this.apiBuilder(options)
  }
  apiBuilder({ config = {} }) {
    Object.keys(config).map(modulename => {
      this.apiSingleBuilder({
        modulename,
        apiList: config[modulename]
      })
    })
  }
  apiSingleBuilder({ modulename = '', apiList = [] }) {
    apiList.forEach(api => {
      const { name, path, method, params, mock } = api
      const apiName = `${modulename}/${name}`
      if (!name) {
        console.warn(new Error('apiSingleBuilder: API name不能为空'))
        return
      }
      Object.defineProperty(this.api, apiName, {
        value(outerParams, outerOptions) {
          if (process.env.NODE_ENV === 'development' && mock) {
            return new Promise(resolve => {
              setTimeout(() => {
                resolve(mock)
              }, Math.random() * 2000)
            })
          } else {
            // 合并参数
            /*let validParams = {}
            let allParams = assign({}, params, outerParams)
            validParams = Object.keys(params).length ? pick(allParams, Object.keys(params)) : outerParams
            return axios(normalizeReq({ url: path, method }, validParams))*/
            let _params = isEmpty(outerParams) ? params : assign({}, params, outerParams)
            let _data = Object.keys(params).length ? pick(_params, Object.keys(params)) : outerParams
            const url = _replaceUrlParams(path, _params)
            const options = assign({ url, method }, outerOptions)
            return axios(_normalize(options, _data))
          }
        }
      })
    })
  }
}

function _replaceUrlParams (url, data) {
  if (typeof data === 'number' || typeof data === 'string') {
    return url + data
  }
  return url
    .replace(/:([\w\d]+)/ig, (reg, key) => data[key])
    .replace(/{([\w\d]+)}/ig, (reg, key) => data[key])
}

function _normalize (options, data) {
  const method = options.method.toUpperCase()
  if (['POST', 'PUT', 'PATCH'].includes(method)) {
    options.data = data
  }else {
    options.params = data
  }
  if (typeof data === 'string' || typeof data === 'number') {
    options.params = {}
  }
  return options
}

export default new ApiMaker({
  config: API_CONFIG
}).api
